<template>
  <div>
    <notifications />
    <v-app :theme="isDark ? 'dark' : 'light'" :class="[
      adminMainStore.personalSetting.miniSideBar ? 'mini-sidebar' : '',
      customizer.setHorizontalLayout ? 'horizontalLayout' : 'verticalLayout',
    ]">
      <slot v-if="!mainStore.isLanding" />
    </v-app>
  </div>
</template>
<script setup lang="ts">
import { useDark, useToggle } from '@vueuse/core';
import { useCustomizerStore } from '~/modules/nuxt3-module-admin-doyac/stores/customizer';
import { useDYAdminMainStore } from '~/modules/nuxt3-module-admin-doyac/stores/main';
import { useDYAppConfig } from '~~/modules/nuxt3-module-doyac/composables/config';

const mainStore = $dy__useDYMainStore()

const isDark = useDark()
const toggleDark = useToggle(isDark)
const customizer = useCustomizerStore();
const adminMainStore = useDYAdminMainStore()
const { siteName } = useDYAppConfig()
const title = ref(siteName);
useHead({
  meta: [{ content: title }],
  titleTemplate: (titleChunk) => {
    return titleChunk
      ? `${titleChunk} - ${siteName}`
      : siteName;
  },
});
const classs = "page-enter";
</script>